<template>
    <div class="tile">
        <div class="tile-title">
            <div class="tile-title-primary">
                <h2 v-fs-block>{{ coupon.redemptionCode }}</h2>
                <span class="text-muted">Created on {{coupon.createdTime | dateTime}}</span>
            </div>
            <div class="tile-title-secondary">
                <h2 v-fs-block>{{ discountValue }} Discount</h2>
                <span class="text-muted">
                Last updated {{coupon.updatedTime | dateTime}}
            </span>
            </div>
        </div>
        <div class="tile-content">
            <p v-if="coupon.description" class="stack-s">{{coupon.description}}</p>
            <r-badge
                :type="getStatusColor(coupon.status)"
            > {{coupon.status | capitalize }}</r-badge>
        </div>
        <div class="tile-content">
            <p>{{couponTimeValidity}}</p>
        </div>
    </div>
</template>

<script>
    import CouponModel from '@/common/models/coupon-model';
    import BADGES_COLOR_MAP from '@/data/badges-color-map';
    import _ from '@/common/helpers';
    import format from '@/common/format';

    export default {
        name: 'coupon-summary',
        props: {
            coupon: Object,
        },
        computed: {
            discountValue() {
                const {
                    discount: {
                        type, value, amount, currency,
                    },
                } = this.coupon;
                if (type === CouponModel.DiscountTypes.percent) {
                    return `${value}%`;
                }
                return `${_.currencySign(currency)}${amount}`;
            },
            couponTimeValidity() {
                const {issuedTime, expiredTime} = this.coupon;
                const now = this.$tz().now();
                const issuedMessage = (() => {
                    if (+this.$tz().readUTC(issuedTime) < +now) {
                        return `was issued on ${format.dateTime(issuedTime)}`;
                    }
                    return `will be issued on ${format.dateTime(issuedTime)}`;
                })();
                const expiredMessage = (() => {
                    if (!expiredTime) {
                        return 'and it will not expire';
                    }
                    if (+this.$tz().readUTC(expiredTime) < +now) {
                        return `and expired on ${format.dateTime(expiredTime)}`;
                    }
                    return `and will expire on ${format.dateTime(expiredTime)}`;
                })();
                return `This coupon ${issuedMessage} ${expiredMessage}.`;
            },
        },
        methods: {
            getStatusColor(status) {
                return BADGES_COLOR_MAP.couponStatus[status];
            },
        },
    };
</script>
